import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import {
  ParametrosOrdenamientosEntity,
  ServicioOrdenamientosService,
  FitlrosOrdenServicioEntity,
  OrdenServicioEntity,
  InfoOrdenamientoEntity
} from 'src/app/services/servicio-ordenamientos.service';
import { ActivatedRoute } from '@angular/router';
import { ServicioEntidadService, EntidadEmpresarialEntity } from 'src/app/services/servicio-entidad.service';
import { ImagesService } from 'src/app/services/utils/images.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-orden-servicios',
  templateUrl: './reporte-orden-servicios.component.html',
  styleUrls: ['./reporte-orden-servicios.component.css']
})
export class ReporteOrdenServiciosComponent implements OnInit {

  filtros: FitlrosOrdenServicioEntity;
  parametros: ParametrosOrdenamientosEntity = {} as ParametrosOrdenamientosEntity;
  ordenesAgrupadas: OrdenServicioEntity[][] = [[]];
  entidadEmpresarial: EntidadEmpresarialEntity;
  infoOrdenamiento: InfoOrdenamientoEntity;
  validoHasta: any;

  now = new Date();
  mensajeLoading: string = 'Cargando...';
  mensajeError: string;
  logo: string;

  constructor(private activatedRoute: ActivatedRoute,
    private ordenamientosService: ServicioOrdenamientosService,
    private servicioEntidad: ServicioEntidadService,
    private servicioImagenes: ImagesService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.parametros.codigo = params['codigoBaseDatos'];
      this.parametros.uncoSede = Number(params['uncoSede']);
      this.parametros.uncoLogin = Number(params['uncoLogin']);
      this.parametros.unco = Number(params['uncoAdmision']);
      this.parametros.uncoTransaccion = Number(params['uncoTransaccion']);
      this.parametros.uncoHc = Number(params['uncoHc']);
    });
  }

  ngOnInit() {
    this.getLogo();
  }

  onFiltrosCompletados(filtros: FitlrosOrdenServicioEntity) {
    this.filtros = filtros;
    this.getOrdenesServicios();
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información del logo entidad ...';
      const response = await this.servicioImagenes.getLogo(this.parametros.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenServiciosComponent.getLogo()', err);
        this.onError('Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenServiciosComponent.getLogo()', e);
      this.onError('Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador.');
    }
  }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.parametros.codigo, this.parametros.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('No se pudo cargar la información de la entidad empresarial. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenServiciosComponent.getEntidadEmpresarial()', err);
        this.onError('Error al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenServiciosComponent.getEntidadEmpresarial()', e);
      this.onError('Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getOrdenesServicios() {
    try {
      this.mensajeLoading = 'Cargando ordenes de servicios ...';
      const response = await this.ordenamientosService.getOrdenesServicios(this.parametros, this.filtros);
      response.subscribe((data: any) => {
        if (data && data['#result-set-1'].length > 0) {
          const ordenes = this.ordenamientosService.getOrdenesServicioEntity(data['#result-set-1']);
          const { impresionServicios, discriminarServicios, discriminarNoPos } = this.filtros;
          this.ordenesAgrupadas = ordenes.reduce((prev, current) => {
            for (let index = 0; index < prev.length; index++) {
              const first = prev[index][0];
              if (impresionServicios) {
                if (first['codigoProcedimiento'] === current['codigoProcedimiento']) {
                  prev[index].push(current);
                  return prev;
                }
              } else if (discriminarServicios && discriminarNoPos) {
                if (first['lineaProducto'] === current['lineaProducto'] &&
                  first['pos'] === current['pos']) {
                  prev[index].push(current);
                  return prev;
                }
              } else if (discriminarServicios) {
                if (first['lineaProducto'] === current['lineaProducto']) {
                  prev[index].push(current);
                  return prev;
                }
              } else if (discriminarNoPos) {
                if (first['pos'] === current['pos']) {
                  prev[index].push(current);
                  return prev;
                }
              } else {
                prev[0].push(current);
                return prev;
              }
            }
            prev.push([current]);
            return prev;
          }, []);

          this.getInfoAdicionalOrdenamiento();
        } else {
          this.onError('No se pudo cargar la información de las ordenes de servicios. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenServiciosComponent.getOrdenesServicios()', err);
        this.onError('Error al obtener información de las ordenes de servicios, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenServiciosComponent.getOrdenesServicios()', e);
      this.onError('Error grave al obtener información de las ordenes de servicios, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getInfoAdicionalOrdenamiento() {
    try {
      const response = await this.ordenamientosService.getInfoAdicionalOrdenamiento(this.parametros,
        this.filtros.profesionales[0]);

      response.subscribe((data: any) => {
        if (data && data['diasValidez']) {
          this.infoOrdenamiento = this.ordenamientosService.getInfoOrdenamientoEntity(data);
          this.validoHasta = moment(this.filtros.fechaInicio, 'YYYY-MM-DD')
            .add(this.infoOrdenamiento.diasValidez, 'days');

          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('No se pudo cargar la información de la orden de servicios. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenServiciosComponent.getInfoAdicionalOrdenamiento()', err);
        this.onError('Error al obtener información de la orden de servicios, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenServiciosComponent.getInfoAdicionalOrdenamiento()', e);
      this.onError('Error grave al obtener información de la orden de servicios, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  getDescripcionDiagnostico(key: 'diagnostico' | 'diagnosticoRel1' | 'diagnosticoRel2') {
    let descripcionDiagn = '--';
    if (this.infoOrdenamiento && this.infoOrdenamiento[key]) {
      const { descripcion, codigoDiagnostico, activaDescripcion } = this.infoOrdenamiento[key];
      if (activaDescripcion) {
        descripcionDiagn = `(${codigoDiagnostico}) ${descripcion}`;
      } else {
        if (codigoDiagnostico !== undefined && codigoDiagnostico.trim().length > 0) {
          descripcionDiagn = `(${codigoDiagnostico})`
        }
      }
    }
    return descripcionDiagn;
  }

  onErrorGenerado(mensajeError: string) {
    this.mensajeError = mensajeError;
  }

  onError(msj) {
    this.mensajeLoading = null;
    this.mensajeError = msj;
  }

  isLoading(): boolean {
    return this.mensajeLoading && this.mensajeLoading.length > 0
      && !this.isError();
  }

  isError(): boolean {
    return this.mensajeError && this.mensajeError.length > 0;
  }

  isReady(): boolean {
    return !this.isLoading() && !this.isError();
  }

}
